export const GET_PASS_OFFERS = 'GET_PASS_OFFERS';
export const GET_PASS_OFFERS_SUCCESS = 'GET_PASS_OFFERS_SUCCESS';
export const GET_PASS_OFFERS_ERROR = 'GET_PASS_OFFERS_ERROR';

export const ACCEPT_PASS_OFFERS = 'ACCEPT_PASS_OFFERS';
export const ACCEPT_PASS_OFFERS_SUCCESS = 'ACCEPT_PASS_OFFERS_SUCCESS';
export const ACCEPT_PASS_OFFERS_ERROR = 'ACCEPT_PASS_OFFERS_ERROR';

export interface PassOffersRequest {
    userId: string;
    salesChannelId: number;
}

export interface AcceptPassOffersRequest {
    userUuid: string;
    offerId: number;
}

export interface PassOffersSingle {
    id: number;
    is_offer_accepted: boolean;
    event_id: string;
    title: string;
    venue: string;
    time: string;
    timezone: string;
    security_phrase: string;
    league: string;
    avfms_sport: string;
    logo_url: string;
    away_team_logo_url: string;
    status: number;
    sales_channel_id: number;
    quantity: number;
}

export interface PassOffersError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    name?: string;
    status?: number;
}

export interface PassOffersState {
    data: Array<PassOffersSingle> | null;
    loading: boolean;
    error: PassOffersError | null;
}

export interface GetPassOffersAction {
    type: typeof GET_PASS_OFFERS;
}

export interface GetPassOffersSuccessAction {
    type: typeof GET_PASS_OFFERS_SUCCESS;
    payload: Array<PassOffersSingle>;
}

export interface GetPassOffersErrorAction {
    type: typeof GET_PASS_OFFERS_ERROR;
    payload: PassOffersError;
}

export interface AcceptPassOffersAction {
    type: typeof ACCEPT_PASS_OFFERS;
}

export interface AcceptPassOffersSuccessAction {
    type: typeof ACCEPT_PASS_OFFERS_SUCCESS;
    payload: { is_offer_accepted: boolean; offerId: number };
}

export interface AcceptPassOffersErrorAction {
    type: typeof ACCEPT_PASS_OFFERS_ERROR;
    payload: PassOffersError;
}

export type PassOffersAction =
    | GetPassOffersAction
    | GetPassOffersSuccessAction
    | GetPassOffersErrorAction
    | AcceptPassOffersAction
    | AcceptPassOffersSuccessAction
    | AcceptPassOffersErrorAction;
